<template lang="pug">
  ValidationObserver
    .u-mt-mi.u-mb-mi.u-textCenter(slot-scope="{ validate }")
      button.button-link.is-medium(@click="overlayOpen = true") {{ message }}
      Overlay(:is-open.sync="overlayOpen" :centered="true")
        form(novalidate @submit.prevent="validate().then(submit)")
          .grid
            .column
              TextInput(
                :label="$t('forms.feedback')"
                v-model="value"
                name="feedback"
                type="textarea"
                rules="required"
              )

          button.button-link.is-medium(v-load="isSubmitting") {{ $t('forms.send') }}
</template>

<script>
import { mapActions } from 'vuex';
import { load } from '~/directives';
import Overlay from '~/components/Overlay';
import CreateFeedback from '~/graphql/Feedback.gql';
import TextInput from '~/components/inputs/TextInput';
import { ValidationObserver } from 'vee-validate/dist/vee-validate.minimal';

export default {
  name: 'FeedbackForm',
  components: {
    ValidationObserver,
    TextInput,
    Overlay
  },
  directives: { load },
  props: {
    message: {
      type: String,
      required: true
    },
    entityId: {
      type: String,
      required: true
    },
    entityType: {
      type: String,
      required: true
    }
  },
  data: () => ({
    value: '',
    overlayOpen: false,
    isSubmitting: false
  }),
  methods: {
    ...mapActions({
      success: 'alert/success',
      error: 'alert/error'
    }),
    async submit() {
      try {
        this.isSubmitting = true;
        this.$api.mutate({
          mutation: CreateFeedback,
          variables: {
            input: {
              entityId: this.entityId,
              entityType: this.entityType,
              type: 'COMMENT',
              value: this.value
            }
          }
        });
        this.success(this.$t('submitted'));
        this.overlayOpen = false;
      } catch (err) {
        this.error(err.message);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "submitted": "Thanks for your feedback!"
  },
  "ar": {
    "submitted": "شكراً على ابداء رأيك"
  }
}
</i18n>
